import Axios from "axios";
import Vue from "vue";

export const Get = (url, params, headers, config = {}) => {
	return new Promise((resolve, reject) => {
		Axios.get(url, {
			headers,
			params,
			responseType: 'json',  // 默认值
			// 其他传递的配置会覆盖默认配置
			...config,
		}).then(res => {
			if (res && res.code == 200) {
				resolve(res.data)
			} else if (config.responseType == 'blob' && res.status == 200) {
				resolve(res)
			} else {
				reject(res)
			}
		}).catch(error => {
			reject(error)
		})
	});
}

export const Post = (url, data, params, headers, config = {}) => {
	return new Promise((resolve, reject) => {
		Axios.post(url, data, {
			headers,
			params,
			responseType: 'json',  // 默认值
			// 其他传递的配置会覆盖默认配置
			...config
		}).then(res => {
			if (res && res.code == 200) {
				resolve(res.data)
			} else {
				reject(res)
			}
		}).catch(error => {
			reject(error)
		})
	});
}

Vue.prototype.HttpUtil = {
	Post,
	Get
};
